<template>
  <PageHeaderLayout title="业务认证" isBack>
  <div class="mainContent radius">
    <xl-back title="业务认证"></xl-back>
    <div class="wrap">
      <div id="pdfArea">
        <div class="name">业务信息</div>
        <div class="border"></div>
        <div class="formArea">
          <el-form
            ref="ref_form_step1"
            :model="authForm"
            :rules="authRules"
            label-width="120px"
            class="left"
          >
            <el-form-item label="公司名称" prop="CompanyName">
              <el-input v-model.trim="authForm.CompanyName" placeholder="请输入公司名称" />
            </el-form-item>
            <el-form-item label="负责人姓名" prop="ContactsName">
              <el-input v-model.trim="authForm.ContactsName" placeholder="请输入负责人姓名" />
            </el-form-item>
            <el-form-item label="从事行业" prop="category_type_ids">
              <el-cascader
                v-model="authForm.category_type_ids"
                :options="state.category_list"
                :props="categoryProps"
                clearable
                filterable
                placeholder="请选择从事行业"
              />
            </el-form-item>
            <el-form-item label="所需通道" prop="Channels">
              <el-select
                v-model="authForm.Channels"
                multiple
                clearable
                placeholder="请选择所需通道"
              >
                <el-option label="支付宝" value="ALIPAY" />
                <el-option label="微信" value="WECHAT" />
                <el-option label="银行卡" value="BANK" />
              </el-select>
            </el-form-item>
            <el-form-item label="结算量" prop="Money">
              <el-input v-model.trim="authForm.Money" placeholder="请输入结算量">
                <template slot="append">万/月</template>
              </el-input>
            </el-form-item>
            <el-form-item label="业务介绍" prop="Remark">
              <el-input
                v-model.trim="authForm.Remark"
                type="textarea"
                :rows="4"
                placeholder="请输入业务介绍"
              />
            </el-form-item>
          </el-form>
          <el-form
            ref="ref_form_step2"
            :model="authForm"
            :rules="authRules"
            label-width="120px"
          >
            <el-form-item label="企业类型" prop="CompanyType">
              <el-select v-model="authForm.CompanyType" placeholder="请选择企业类型">
                <el-option label="用工企业" :value="2" />
                <el-option label="人资公司" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="负责人电话" prop="ContactsMobile">
              <el-input
                v-model.trim="authForm.ContactsMobile"
                placeholder="请输入负责人电话"
              />
            </el-form-item>
            <el-form-item label="发票类型" prop="InvoiceType">
              <el-radio-group v-model="authForm.InvoiceType">
                <el-radio :label="1">专票</el-radio>
                <el-radio :label="2">普票</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自由职业者数量" prop="PersonNum">
              <el-input
                v-model.trim="authForm.PersonNum"
                placeholder="请输入自由职业者数量"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="actionWrap">
        <el-button plain class="cancel" @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="event_ensure">提交</el-button>
      </div>
    </div>
  </div>
</PageHeaderLayout>
</template>

<script>
import { debounce } from "@/utils/utils.js";
import { gettreeList } from "@/utils/utils.js";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
  name: "AuthNlg",
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      submitAuthData: {},
      authForm: {
        CompanyName: this.getNowCompanyName(),
        ContactsName: "",
        category_type_ids: [],
        Channels: [],
        Money: "",
        Remark: "",
        CompanyType: 1,
        ContactsMobile: "",
        InvoiceType: 1,
        PersonNum: "",
      },
      categoryProps: {
        multiple: true,
        value: "value",
        label: "label",
        checkStrictly: true,
        emitPath: false,
      },
      authRules: {
        CompanyName: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        ContactsName: [{ required: true, message: "请输入负责人姓名", trigger: "blur" }],
        category_type_ids: [
          { required: true, message: "请选择从事行业", trigger: "change" },
        ],
        Channels: [{ required: true, message: "请选择所需通道", trigger: "change" }],
        Money: [{ required: true, message: "请输入结算量", trigger: "blur" }],
        Remark: [{ required: true, message: "请输入业务介绍", trigger: "blur" }],
        CompanyType: [{ required: true, message: "请选择企业类型", trigger: "change" }],
        ContactsMobile: [{ required: true, message: "请输入负责人电话", trigger: "blur" }],
        InvoiceType: [{ required: true, message: "请选择发票类型", trigger: "change" }],
        PersonNum: [{ required: true, message: "请输入自由职业者数量", trigger: "blur" }],
      },
      state: {
        casOption: {
          multiple: true,
          checkStrictly: true,
          label: "label_category_name",
          value: "id",
        },
        checkList: [],
        form: {},
        formInvoice: [
          {
            label: "企业类型",
            type: "select",
            typeData: [
              {
                label: "用工企业",
                val: 2,
              },
              {
                label: "人资公司",
                val: 1,
              },
            ],
            field: "CompanyType",
            val: 1,
            required: true,
          },
          {
            label: "负责人电话",
            type: "input",
            field: "ContactsMobile",
            val: "",
            required: true,
          },
          {
            label: "发票类型",
            type: "radioGroup",
            typeData: [
              {
                label: "专票",
                val: 1,
              },
              {
                label: "普票",
                val: 2,
              },
            ],
            field: "InvoiceType",
            val: 1,
            required: true,
          },
          {
            label: "自由职业者数量",
            type: "input",
            field: "PersonNum",
            val: "",
            required: true,
          },
        ],
        empAuth: [
          {
            label: "公司名称",
            type: "input",
            field: "CompanyName",
            val: "",
            required: true,
          },
          {
            label: "负责人姓名",
            type: "input",
            field: "ContactsName",
            required: true,
          },
          {
            label: "从事行业",
            type: "cascader",
            typeData: [],
            field: "category_type_ids",
            typeOptions: {
              multiple: true,
              value: "id",
              label: "label_category_name",
              checkStrictly: true,
              emitPath: false,
            },
            val: "",
            required: true,
          },
          {
            label: "所需通道",
            type: "select",
            typeOptions: { multiple: true },
            typeData: [
              {
                label: "支付宝",
                val: "ALIPAY",
              },
              {
                label: "微信",
                val: "WECHAT",
              },
              {
                label: "银行卡",
                val: "BANK",
              },
            ],
            field: "Channels",
            val: [],
            required: true,
          },
          {
            label: "结算量",
            type: "input",
            field: "Money",
            val: "",
            required: true,
          },
          {
            label: "业务介绍",
            type: "textarea",
            field: "Remark",
            val: "",
            required: true,
          },
        ],
        category_list: [],
      },
    };
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    getNowCompanyName() {
      try {
        const nowCompany = JSON.parse(localStorage.getItem("nowCompany") || "{}");
        return nowCompany.name || "";
      } catch (error) {
        return "";
      }
    },
    handleCancel() {
      this.$router.back();
    },
    getCategoryTypeName(ids, categoryList) {
      let categoryNameList = [];
      const getChildrenList = (arr) => {
        for (let index = 0; index < arr.length; index += 1) {
          if (arr[index].children && arr[index].children.length) {
            getChildrenList(arr[index].children);
          }

          if (ids.includes(arr[index].value)) {
            categoryNameList.push(arr[index].label);
          }
        }

        return categoryNameList;
      };
      getChildrenList(categoryList);
      return categoryNameList;
    },
    // 获取行业列表
    async getCategoryList() {
      const res = await this.$api.categoryList({});
      this.state.category_list = gettreeList(res, "label_category_name", "id");
      this.state.empAuth.forEach((item) => {
        if (item.field == "category_type_ids") {
          item.typeData = this.state.category_list;
        }
      });
    },
    validateForm(refName) {
      return new Promise((resolve) => {
        this.$refs[refName].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async event_ensure() {
      const [step1Valid, step2Valid] = await Promise.all([
        this.validateForm("ref_form_step1"),
        this.validateForm("ref_form_step2"),
      ]);
      if (!step1Valid || !step2Valid) {
        return;
      }

      let obj = {
        ...this.authForm,
        ...this.state.form,
        Source: 2,
      };

      if (obj.category_type_ids) {
        obj.Type = obj.category_type_ids.join(",");
        obj.TypeName = this.getCategoryTypeName(
          obj.category_type_ids,
          this.state.category_list
        );
        obj.TypeName = obj.TypeName.join(",");
        delete obj.category_type_ids;
      }
      obj.Channels = obj.Channels.join(",");
      this.submitAuthData = obj;
      this.lgAuth();
    },
    // 灵工认证提交数据
    lgAuth: debounce(async function() {
      await this.$api.postLgAuth({
        ...this.submitAuthData,
      });
      this.$message.success("操作成功");
      setTimeout(() => {
        this.$router.back();
      }, 2000);
    }),
  },
};
</script>

<style scoped lang="scss">
.actionWrap {
  margin: 20px 0px;
  .cancel {
    margin-right: 20px;
  }
}

.formArea {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .left {
    margin-right: 120px;
  }
  .el-form {
    width: 420px;
  }
  .el-select,
  .el-cascader {
    width: 100%;
  }
}
.name {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  font-weight: 400;
  color: #121212;
  margin-bottom: 40px;
}
.border {
  margin-bottom: 40px;
}
.mainContent {
  overflow: auto;
}
.area {
  margin-left: 40px;
}
.wrap {
  padding: 0px 20px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
